export const CAPTCHA_COOLDOWN_STORAGE_KEY = 'authCaptchaCooldownUntil';

export const clearCaptchaCooldownStorage = () => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(CAPTCHA_COOLDOWN_STORAGE_KEY);
  }
};
